module.exports = __webpack_public_path__ + "img/hero@2x-2.47d6c93b.webp";